import { render, staticRenderFns } from "./FormErrorResult.vue?vue&type=template&id=01bf87a8&"
import script from "./FormErrorResult.vue?vue&type=script&lang=js&"
export * from "./FormErrorResult.vue?vue&type=script&lang=js&"
import style0 from "./FormErrorResult.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/public/forms/components/FormErrorResult.vue
// module id = 372
// module chunks = 0